import React from 'react';
import styles from './MottoComponent.module.css';
import '../styles/theme.css';

function MottoComponent() {
  return (
    <section className={styles['motto']}>
      <div className={styles['motto-inner']}>
        <div className={styles['motto-latin']}>
          <span>P<span className={styles['motto-tail']}>rimum</span> </span>
          <span className={styles['motto-block']}>
            <span className={styles['motto-block-bg']} aria-hidden="true" />
            <span className={styles['motto-block-text']}>N<span className={styles['motto-tail']}>on</span>&nbsp;D<span className={styles['motto-tail']}>esipere</span></span>
          </span>
        </div>
        <p className={styles['motto-explanation']}>
          <em>“First, do not act foolishly.”</em> A commitment to wisdom and
          discernment, reflecting the pursuit of excellence and thoughtful
          consideration in all we do.
        </p>
      </div>
    </section>
  );
}

export default MottoComponent;
